export default {
  en: {
    like: {
      zero: 'Like',
      one: '%{count} like',
      other: '%{count} likes',
    },
    reply: {
      zero: 'Reply',
      one: '%{count} reply',
      other: '%{count} replies',
    },
    comment_was_deleted: 'This comment was deleted',
  },
};
